/* eslint-disable eqeqeq */
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/vi";
import relativeTime from "dayjs/plugin/relativeTime";
import Utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday";
import { getLocaleKey } from "../languages";
import { Moment } from "moment";

dayjs.extend(weekday);
dayjs.extend(relativeTime);
dayjs.extend(Utc);

const getHHmmFormat = (date: any) => {
  return dayjs(date).local().format("HH:mm");
};

const getHHmm2Format = (date: any) => {
  return dayjs(date).utc().format("HH:mm");
};

const getDDMMYYYFormat = (date: any) => {
  return date ? new Date(date).toLocaleDateString(getLocaleKey()) : "";
};

const getUCTDate = (date?: any) => {
  if (!date) return dayjs().utc().format();
  return dayjs.utc(date).format();
};

const getLocalDate = (date: any) => {
  return dayjs(date).local().format();
};

const getLocalDate2 = (date: any) => {
  return dayjs(date).local().toDate();
};

const getTimeRangeAllDay = () => {
  const date = dayjs();
  const start = date.hour(0).minute(0).format("HH:mm");
  const end = date.hour(0).minute(0).format("HH:mm");
  return [start, end];
};

const getStartDayOfWeek = () => {
  const date = dayjs().locale("vi").weekday(0);
  return date;
};

const getStartDayOfMonth = () => {
  const date = dayjs().locale("vi").startOf("month");
  return date;
};

const getEndDayOfMonth = () => {
  const date = dayjs().locale("vi").endOf("month");
  return date;
};

const getStartDayOfYear = () => {
  const date = dayjs().locale("vi").startOf("year");
  return date;
};

const getEndDayOfYear = () => {
  const date = dayjs().locale("vi").endOf("year");
  return date;
};

const setUtcWithoutTime = (date?: Dayjs) => {
  if (!date) return dayjs().utc().hour(0).minute(0).second(0).format();
  return date.utc().hour(0).minute(0).second(0).format();
};

const setUtcTime = (date?: Dayjs) => {
  if (!date) return dayjs().utc().format();
  return date.utc().format();
};

const getDay = (date?: any) => {
  return date ? dayjs(date) : dayjs();
};

const getDate = (date?: any) => {
  return date ? dayjs(date).date() : dayjs().date();
};

const getMonth = (date?: any) => {
  return date ? dayjs(date).month() : dayjs().month();
};

const getYear = (date?: any) => {
  return date ? dayjs(date).year() : dayjs().year();
};

const getTotalDay = (start: string, end: string) => {
  return dayjs(end).diff(dayjs(start), "day", true) + 1;
};

const getDiffDay = (start: string, end: string) => {
  return dayjs(end).diff(dayjs(start), "day");
};

const isDocumentExpired = (effectiveTo: string) => {
  const today = new Date();
  return getDiffDay(effectiveTo, today.toDateString()) >= 0;
};


const getGenTime = (timeString: string) => {
  let H = +timeString.substr(0, 2);
  let h = H % 12 || 12;
  let ampm = H < 12 ? " AM" : " PM";
  return { label: h + timeString.substr(2, 3) + ampm, value: timeString };
};

const returnTimesInBetween = () => {
  const start = "00:00:00";
  const end = "24:00:00";
  var timesInBetween = [];

  var startH = parseInt(start.split(":")[0]);
  var startM = parseInt(start.split(":")[1]);
  var endH = parseInt(end.split(":")[0]);
  var endM = parseInt(end.split(":")[1]);

  if (startM == 30) startH++;

  for (var i = startH; i < endH; i++) {
    timesInBetween.push(i < 10 ? "0" + i + ":00" : i + ":00");
    timesInBetween.push(i < 10 ? "0" + i + ":30" : i + ":30");
  }

  timesInBetween.push(endH + ":00");
  if (endM == 30) timesInBetween.push(endH + ":30");

  return timesInBetween.map(getGenTime);
};

const getDayInMiSec = () => {
  return dayjs().unix();
};

const addYear = (today: any, year: number = 1) => {
  let date = new Date(today); // Get the date object from the input parameter
  date.setFullYear(date.getFullYear() + year); // Add one year to the current year
  return date; // Return the new date
};

const addDays = (today: any, days: number): Date => {
  let date = new Date(today);
  date.setDate(date.getDate() + days);
  return date;
};

const convertToDate = (dateString: string) => {
  //  Convert a "dd/MM/yyyy" string into a Date object
  const d = dateString.split("/");
  const dat = new Date(d[2] + "/" + d[1] + "/" + d[0]);
  return dat;
};

const isDateInRange = (date: Moment, start: Moment, end: Moment): boolean => {
  return date.isBetween(start, end, null, "[]");
};

export {
  getUCTDate,
  getLocalDate,
  getLocalDate2,
  getHHmmFormat,
  getTimeRangeAllDay,
  getStartDayOfWeek,
  setUtcWithoutTime,
  getStartDayOfMonth,
  getEndDayOfMonth,
  getDay,
  getDate,
  getMonth,
  getYear,
  getTotalDay,
  returnTimesInBetween,
  getDiffDay,
  getDDMMYYYFormat,
  setUtcTime,
  getStartDayOfYear,
  getEndDayOfYear,
  getDayInMiSec,
  addYear,
  addDays,
  getHHmm2Format,
  convertToDate,
  isDateInRange,
  isDocumentExpired
};
